<div class="layout">
    <div class="header-section">
        <img src="HomeBannerCastleOnly.png" fetchPriority="high" class="background-image">
        <div class="intro-container">
            <p class="intro-text-title">{{'privacy.header' | translate}}</p>
        </div>
    </div>
    <div class="text-section">
        <h1>{{'privacy.title' | translate}}</h1>

        <div class="chapter">
            <h3>{{'privacy.chapter1.title' | translate}}</h3>
            <p>{{'privacy.chapter1.text' | translate}}</p>
            <p>
                <span *ngFor="let line of ('privacy.chapter1.breaks' | translate)">{{line}}<br></span>
            </p>
        </div>

        <div class="chapter">
            <h3>{{'privacy.chapter2.title' | translate}}</h3>
            <p>{{'privacy.chapter2.text' | translate}}</p>
            <ul>
                <li>{{'privacy.chapter2.list1' | translate}}</li>
                <li>{{'privacy.chapter2.list2' | translate}}</li>
                <li>{{'privacy.chapter2.list3' | translate}}</li>
            </ul>
            <p>{{'privacy.chapter2.text2' | translate}}</p>
        </div>

        <div class="chapter">
            <h3>{{'privacy.chapter3.title' | translate}}</h3>
            <p>{{'privacy.chapter3.text' | translate}}</p>
        </div>

        <div class="chapter">
            <h3>{{'privacy.chapter4.title' | translate}}</h3>
            <p>{{'privacy.chapter4.text' | translate}}</p>
        </div>

        <div class="chapter">
            <h3>{{'privacy.chapter5.title' | translate}}</h3>
            <p>{{'privacy.chapter5.text' | translate}}</p>
            <ul>
                <li>{{'privacy.chapter5.list1' | translate}}</li>
                <li>{{'privacy.chapter5.list2' | translate}}</li>
                <li>{{'privacy.chapter5.list3' | translate}}</li>
                <li>{{'privacy.chapter5.list4' | translate}}</li>
                <li>{{'privacy.chapter5.list5' | translate}}</li>
                <li>{{'privacy.chapter5.list6' | translate}}</li>
            </ul>
        </div>

        <div class="chapter">
            <h3>{{'privacy.chapter6.title' | translate}}</h3>
            <p>{{'privacy.chapter6.text' | translate}}</p>
        </div>

        <div class="chapter">
            <h3>{{'privacy.chapter7.title' | translate}}</h3>
            <p>{{'privacy.chapter7.text' | translate}}</p>
        </div>
    </div>
</div>
